// PR-P4 — open a subject's bank-statement PDF (reuses the ledger pdfkit route).
import { apiClient, getStoredToken } from './api';

export async function openStatementPdf(
  kind: 'vehicle' | 'driver', id: string, from?: string, to?: string,
): Promise<void> {
  const qs = new URLSearchParams({ scope: 'neom' });
  if (from) qs.set('from', from);
  if (to) qs.set('to', to);
  // PR-R4 — branded NEOM statement (grouped by site, manual payments, running
  // balance) from the project-reports renderer.
  const url = `/api/v1/project-reports/${kind}/${id}/statement.pdf?${qs.toString()}`;
  const token = getStoredToken();
  const resp = await fetch(`${apiClient.defaults.baseURL ?? ''}${url}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!resp.ok) throw new Error(`PDF download failed (HTTP ${resp.status})`);
  const blob = await resp.blob();
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
  setTimeout(() => URL.revokeObjectURL(blobUrl), 30_000);
}
